<template>
  <div class="home h-100">
    <!-- Navigation -->
    <CoralstoneUnitNavbar />
    <section class="unit-header">
        <div class="overlay"></div>
        <div class="container">
            <div class="unit-wrapper">
                
                <div class="backBtn-wrapper">
                    <a @click="$router.push({ name: 'Home'})" href="#" class="btn">
                        <span class="fas fa-arrow-left"></span>
                        <span class="ml-2 back">Back</span>
                    </a>
                </div>
                    
                <div class="header-text-wrapper">
                    <div class="header-text">
                        <h1>Ambission <span>Bureau De Change</span></h1>
                        <p>CBN licenced wholesale & retail trade foreign exchange company</p>
                        <a href="#" class="btn btn-primary">Visit Website</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="who-we-are">
      <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="who-text">
                    <h3>Who are we?</h3>
                </div>
            </div>
            <div class="col-md-8">
                <div class="main-text">
                    <p>Ambission BDC is licensed by the Central Bank of Nigeria (CBN) to operate as a foreign exchange company, dealing in large-volume wholesale as well as retail trades of major global currencies.</p>
                    <p>
                        Competitive rates, fast and secure trades, strong customer support, and lots of value-added services are some of the reasons why our customers always choose us.
                    </p>
                    <p>We offer reliable foreign exchange and brokerage services to individuals and corporations, including cash purchase and sales of forex, sale of Business Travel Allowance (BTA) and Personal Travel Allowance (PTA), credit card payment services, as well as facilitating other international payments.</p>
                    <p>We take pride in our ability to maintain long-term relationships built on trust, reliability and ease of doing business with us.</p>
                </div>
            </div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import CoralstoneUnitNavbar from "./CoralstoneUnitNavbar"

export default {
  name: 'Home',
  components: {
    CoralstoneUnitNavbar,
    Footer
  },
  
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .unit-header {
      position: relative;
      background: url('../../public/img/ambission.jpg') no-repeat;
      background-size: cover;
      height: 600px;

      .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #171F4A;
        mix-blend-mode: multiply;
        opacity: 0.85;
        }

        .unit-wrapper {
            position: relative;

            .backBtn-wrapper {
                position: absolute;
                top: 6rem; 
                left: 0;

               .back {
                    font-family: Source Sans Pro;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 16px;
                    line-height: 20px;
                    color: #fff;
                }

                .fa-arrow-left {
                    color: #fff;
                }
            }

            .header-text-wrapper {
                position: absolute;
                top: 16rem;
                left: 0;

                .header-text {
                    h1 {
                   font-family: Inter, sans-serif;
                    font-style: normal;
                    font-weight: 800;
                    font-size: 62px; 
                    line-height: 64px;

                    span {
                        display: block;
                    }
                   
                    }

                    h1, p {
                        color: #fff;
                    }

                    p {
                        font-family: Inter, sans-serif;
                        font-style: normal;
                        font-weight: 500;
                        font-size: 24px;
                        line-height: 34px;
                        width: 50%;
                        letter-spacing: 0.02em;
                        width: 70%;
                    }

                    .btn-primary {
                        background-color: #04ACEC !important;
                        border-color: #04ACEC !important;
                        color: #fff;
                        font-family: Montserrat;
                        font-style: normal;
                        font-weight: 600;
                        font-size: 16px;
                        line-height: 20px;
                        letter-spacing: 0.02em;
                        text-transform: uppercase;
                        border-radius: 8px;
                        padding: 0.6rem 1rem;

                        &:hover {
                            background-color: #1c91c0 !important;
                            border-color: #1c91c0 !important;
                        }

                        &:focus {
                            outline: none;
                            box-shadow: none !important;
                        }
                    }
                }

            }

        }
  }

  // who we are styles
  .who-we-are {
    padding: 4rem 0 6rem;

    .who-text {
        background: #171F4A;
        padding-left: 1rem;
        border-bottom: 2px solid #94248C;

        h3 {
            font-family: Inter, sans-serif;
            font-style: normal;
            font-weight: 800;
            font-size: 32px;
            line-height: 48px;
            letter-spacing: 0.02em;
            color: #fff;
        }
    }

    .main-text {
        p {
            font-family: Inter;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 23px;
           color: #28283A;
        }
    }

  }

  
  @media (min-width: 992px) and (max-width: 1199px) {
    .unit-header {
        .unit-wrapper {
            .header-text-wrapper {
                top: 13rem;

                .header-text {
                    h1 {
                    font-size: 62px; 
                    }
                }
            }
        }
    }
    // .who-we-are {

      
    // }
  }

  @media (min-width: 767px) and (max-width: 991px) {
    .unit-header {
    
        .unit-wrapper {
            .header-text-wrapper {
                top: 13rem;

                .header-text {
                    h1 {
                        font-size: 48px; 
                        line-height: 52px;
                    }

                    p {
                        font-size: 22px;
                    }

                    .btn-primary {
                        font-size: 14px;
                    }
                }
            }
        }

    }
    .who-we-are {

        .who-text {
        
            h3 {
                font-size: 26px;
            }
        }

    }
  }

  @media (max-width: 767px) {
    .unit-header {
        .unit-wrapper {
            .header-text-wrapper {
                top: 11rem;

                .header-text {
                    text-align: center;
                    h1 {
                        font-size: 42px; 
                        line-height: 46px; 
                    }

                    p {
                        font-size: 20px;
                        width: 100%;
                    }

                    .btn-primary {
                        font-size: 14px;
                    }
                }
            }
        }

    }
    .who-we-are {

      .who-text {
        
            h3 {
                font-size: 26px;
                margin-bottom: 1rem;
            }
        }
    }
  }

  



</style>

